import React from "react";
import { Button, Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../../redux/slices/auth/authAction";
import { imagesgeneral } from "../../../assets/type_assets";
import "./auth.css";

export const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const state = useSelector((state) => state.auth.loading);

    const onFinish = (values) => {
        dispatch(login(navigate, values));
    };

    return (
        <div className="flex relative w-full h-full bg-white">
            <div className="w-full h-full absolute lg:relative">
                <figure className="w-full h-full lg:w-auto bg-[#3259FF]">
                    <img src={imagesgeneral.loginBg} alt="Fondo" className="h-full  object-cover" />
                </figure>
                <figure className="w-full h-24 lg:h-40 absolute top-8 lg:top-1/2 lg:-translate-y-1/2">
                    <img className="w-full h-full object-contain" src={imagesgeneral.logo_blanco} alt="logo" />
                </figure>
            </div>
            <div className="w-full h-full pt-20 md:pt-0 flex justify-center items-center bg-white">
                <Form
                    name="basic"
                    layout="vertical"
                    size={"middle"}
                    onFinish={onFinish}
                    autoComplete="off"
                    className="w-full max-w-[400px] m-6 p-4 rounded-md bg-white z-10"
                >
                    <article className="mb-6 md:mb-10">
                        <h2 className="text-2xl md:text-4xl text-primaryTwo font-normal mb-8 md:mb-12">Bienvenido a Clickapi</h2>
                        <p className="text-sm font-bold mb-2">Ingresar</p>
                        <div className="flex items-center gap-4">
                            <p className="font-semibold text-xs w-max">Usa tu cuenta de Inmersys</p>
                            <div className="h-[1px] bg-lowGray grow"></div>
                        </div>
                    </article>
                    <Form.Item
                        label="Correo electrónico"
                        validateTrigger={["onBlur"]}
                        name="email"
                        rules={[
                            {
                                required: true,
                                type: "email",
                                message: "Revisa tu email. Asegúrate de que tenga este formato: ejemplo@inmersys.com",

                            },
                            {
                                required: true,
                                message: "Por favor ingresa tu email",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Contraseña"
                        name="password"
                        validateTrigger={["onBlur"]}
                        rules={[
                            {
                                required: true,
                                message: "Por favor ingresa tu contraseña",
                            },
                            {
                                min: 8,
                                required: true,
                                message: "La contraseña son mínimo 8 caracteres",
                            },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item className="flex justify-end m-0">
                        <Button type="primary" className="bg-primaryTwo px-6 py-2 h-full" htmlType="submit" loading={state}>
                            Ingresar
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};
